import firebase from 'firebase';

firebase.initializeApp({
  databaseURL: "https://nishinippon-web-specials.firebaseio.com/"
});
const database = firebase.database();
const refCount = database.ref("tetus_nakamura_like");

let countStop = false;
let $post = $(".js-count-up");
let countObj = {
  count: 0
};
let $layer = $(".modal");

/*
 * クリックイベント
 * ・初期読み込み
 * ・ボタンクリック
 */
$post.on("click", function(e) {
  if (countStop) {
    return;
  }
  let initial = $(e.currentTarget).data("initial");
  countObj[initial] = countObj[initial] + 1;
  postActionCount(initial, countObj[initial]);
  countStop = true;
  $('.c-fixedCounter').addClass('is-clicked');
});

refCount.on("child_added", function(snapshot) {
  // データベースと同期
  countObj[snapshot.key] = snapshot.val();

  defRenderCount({
    id: snapshot.key,
    value: snapshot.val()
  });
});

refCount.on("value", function(snapshot) {
  let snapshotObj = snapshot.val();

  // データベースと同期
  for (let key in snapshotObj) {
    countObj[key] = snapshotObj[key];
  }

  renderCount(snapshot.val());
  $('.c-fixedCounter').css({
    'visibility': 'visible'
  })
});

/*
 * View
 * ・カウント表示
 */
let defRenderCount = function(countObj) {
  let $targetCountObj = $(".js-count-" + countObj.id);

  $targetCountObj.text(separate(countObj.value));
};

let renderCount = function(countObj) {
  for (let key in countObj) {
    if (parseInt($(".js-count-" + key).text(), 10) !== countObj[key]) {
      let $targetCountObj = $(".js-count-" + key);
      let $targetCountObjPost = $targetCountObj.closest(".js-post");

      $targetCountObj.text(separate(countObj[key]));
    }
  }
};

let postActionCount = function(initial, countVal) {
  let arg = {};
  arg[initial] = countVal;
  refCount.update(arg);
};

// 再帰関数でセパレート
function separate(num){
  // 文字列にする
  num = String(num);

  var len = num.length;

  // 再帰的に呼び出すよ
  if(len > 3){
      // 前半を引数に再帰呼び出し + 後半3桁
      return separate(num.substring(0,len-3))+','+num.substring(len-3);
  } else {
      return num;
  }
}